import { render, staticRenderFns } from "./ProductEditPrice.vue?vue&type=template&id=122ce60b&"
import script from "./ProductEditPrice.vue?vue&type=script&lang=js&"
export * from "./ProductEditPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports